import CONSTANTS from "src/constants";
import { getHostname } from "utils/location";

export const isProd = () => {
    const isDev = CONSTANTS.DEV;
    const isStaging = getHostname(window.location).includes(
        "staging.liveheats",
    );
    return !isDev && !isStaging;
};
